import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions2 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-5_mujusa.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-6_yhlefd.png",
    },
    {
      title: "RESOURCES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359393/image-7_b3gibg.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-3 pt-2 md:pb-14 pb-4">
        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6 md:mb-6 mt-2 text-[#152C24]">OFFTAKE PARTNER</h1>

        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745281651/image-2_hblwc2.png"
          alt="Securing Agriculture in Namibia"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />

        <div className="flex-1">
          <section className="bg-white p-6">
            <h2 className="text-[32px] font-bold mb-6 text-[#152C24]">
              <strong className="font-bold text-black">OFFTAKE PARTNERS: </strong>
              What are the benefits?
            </h2>

            <h2 className="font-bold text-[32px] text-black mb-6">
              An offtake partner (like a processor, aggregator, exporter, retailer or wholesaler) plays a key role in buying produce from farmers. Using the Farmnet App, offtake partners gain several strategic and operational benefits that help streamline sourcing, reduce risk, and boost profitability.
            </h2>

            <div className="md:space-y-10 text-[32px] text-[#152C24] mt-10">
              <div>
                <strong>1. Direct Access to Verified Farmers</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Connect directly with registered, traceable farmers.</li>
                  <li>Easier to build long-term supply relationships and avoid unreliable sourcing.</li>
                </ul>
              </div>

              <div>
                <strong>2. Aggregated Supply Planning</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>View available produce quantities, locations, and harvest timelines in real-time.</li>
                  <li>Helps plan logistics, warehousing, and purchase orders in advance.</li>
                </ul>
              </div>

              <div>
                <strong>3. Traceability & Quality Assurance</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Access to digital farm records, including crop type, inputs used, and farm practices.</li>
                  <li>Improves traceability for export compliance and food safety standards.</li>
                </ul>
              </div>

              <div>
                <strong>4. Streamlined Procurement Process</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Place bulk orders, schedule pickups, and manage transactions digitally.</li>
                  <li>Reduces manual paperwork and coordination headaches.</li>
                </ul>
              </div>

              <div>
                <strong>5. Transparent Pricing & Fair Trade</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Engage farmers directly, negotiate prices, and reduce middlemen.</li>
                  <li>Promotes fair pricing and trust, especially with contract farming models.</li>
                </ul>
              </div>

              <div>
                <strong>6. Real-Time Communication</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Share harvest schedules, delivery instructions, or quality requirements instantly.</li>
                  <li>Send updates or notifications to farmer groups or cooperatives.</li>
                </ul>
              </div>

              <div>
                <strong>7. Payment Integration</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Pay farmers directly via mobile money or bank transfer through the app.</li>
                  <li>Secure, fast payments with clear digital records for auditing.</li>
                </ul>
              </div>

              <div>
                <strong>8. Compliance & ESG Reporting</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Easier to document sourcing practices and farmer engagement for ESG, sustainability, or certification requirements.</li>
                  <li>Helps with traceability and social impact reporting.</li>
                </ul>
              </div>

              <div>
                <strong>9. Data & Analytics</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Access dashboards showing sourcing trends, farmer performance, and product flow.</li>
                  <li>Helps optimize procurement strategy and predict supply gaps.</li>
                </ul>
              </div>

              <div>
                <strong>10. Partnership Opportunities</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black text-[32px]">
                  <li>Collaborate with service providers (like transporters or agro-input suppliers) directly through the app.</li>
                  <li>Get involved in donor-funded programs or agri-fintech partnerships linked to the platform.</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Solutions2;
